enum EmailTemplateStatus {
    Active = 90,
    Deleted = 100
}

export default EmailTemplateStatus;

